module.exports = __webpack_public_path__ + "img/drag.c4b07a96.svg";